import React from 'react';
import { Clock, MapPin } from 'lucide-react';
import { getActivityTime, getActivityDuration, getActivityLocation } from '../../utils/itineraryDataProcessor';

/**
 * ActivityTiming Component
 * Displays timing information for activities (shows, dining, rides)
 */
const ActivityTiming = ({ activity, showLocation = true, showDuration = true }) => {
  const time = getActivityTime(activity);
  const duration = getActivityDuration(activity);
  const location = getActivityLocation(activity);

  if (!time && !duration && !location) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1 mt-1">
      {time && (
        <div className="flex gap-2 items-center">
          <Clock className="w-3 h-3 text-gray-500" />
          <span className="text-xs text-gray-600 font-medium">{time}</span>
          {showDuration && duration && (
            <span className="text-xs text-gray-500">({duration})</span>
          )}
        </div>
      )}
      {showLocation && location && (
        <div className="flex gap-2 items-center">
          <MapPin className="w-3 h-3 text-gray-500" />
          <span className="text-xs text-gray-500">{location}</span>
        </div>
      )}
    </div>
  );
};

export default ActivityTiming;
